// Token管理工具 - 使用Cookie存储
const TOKEN_KEY = 'feishu_token';
const COOKIE_DOMAIN = '.markableai.cn';

class AuthService {
  // 存储Token到Cookie（支持跨子域名）
  static setToken(token, days = 7) {
    try {
      const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
      
      // 设置Cookie，支持跨子域名访问
      document.cookie = `${TOKEN_KEY}=${encodeURIComponent(token)}; expires=${expires}; domain=${COOKIE_DOMAIN}; path=/; SameSite=Lax; Secure`;
      
      console.log('Token已存储到Cookie，域名为:', COOKIE_DOMAIN);
    } catch (error) {
      console.error('存储Token失败:', error);
    }
  }

  // 获取Token
  static getToken() {
    try {
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
        const [key, value] = cookie.trim().split('=');
        if (key === TOKEN_KEY) {
          return decodeURIComponent(value);
        }
      }
      return null;
    } catch (error) {
      console.error('获取Token失败:', error);
      return null;
    }
  }

  // 清除Token
  static clearToken() {
    try {
      // 清除Cookie（注意：清除时也需要指定相同的domain）
      document.cookie = `${TOKEN_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${COOKIE_DOMAIN}; path=/; SameSite=Lax; Secure`;
    } catch (error) {
      console.error('清除Token失败:', error);
    }
  }

  // 检查是否已登录
  static isLoggedIn() {
    return !!this.getToken();
  }
}

export default AuthService;